export function MarkUsedResponse(almeState, setAlmeAppState) {
    return (response) => {
        const item = almeState.history.find(h => h.responseRevision === response.responseRevision);
        if (item) {
            item.fromHistory = true;
            setAlmeAppState(Object.assign(Object.assign({}, almeState), { history: [...almeState.history] }));
        }
    };
}
